// EntityCard — card de lista del backoffice (mocks B01 Negocios, B03 Planes, B05 Financieras):
// fila superior con nombre + estado (izq) y un slot `aside` (der, ej. un botón), luego meta, un
// bloque OPCIONAL de métricas y una fila de acciones.
//
// Las métricas son opcionales a propósito: en F1 las filas "Ventas este mes" / "Cobros hoy" NO
// tienen fuente de datos (contradicción C2, ver 03_PANTALLAS-F1) y se omiten; el slot queda listo
// para cuando F2/F3 las alimente, sin rediseñar la card.
import type { ReactNode } from 'react';
import { cn } from '@/lib/cn';

export interface EntityCardProps {
    title: ReactNode;
    /** Slot de estado — típicamente un <StatusBadge/>. */
    status?: ReactNode;
    /** Slot a la derecha del header — típicamente un botón (ej. Activar/Desactivar). */
    aside?: ReactNode;
    /** Línea de metadatos — típicamente un <MetaLine/>. */
    meta?: ReactNode;
    /** Métricas operativas (F2/F3) — omitido en F1. */
    metrics?: ReactNode;
    /** Fila de acciones — típicamente un <CardActions/>. */
    actions?: ReactNode;
    children?: ReactNode;
    className?: string;
}

export function EntityCard({
    title,
    status,
    aside,
    meta,
    metrics,
    actions,
    children,
    className,
}: EntityCardProps) {
    return (
        <div className={cn('rounded-lg border border-border bg-card px-4 py-3', className)}>
            <div className="flex flex-wrap items-start justify-between gap-3">
                <div className="min-w-0 space-y-0.5">
                    <div className="flex items-center gap-2">
                        <span className="text-[13px] font-semibold text-foreground">{title}</span>
                        {status}
                    </div>
                    {meta}
                    {metrics}
                    {children}
                </div>
                {aside ? <div className="flex shrink-0 items-center gap-2">{aside}</div> : null}
            </div>
            {actions ? <div className="mt-2.5">{actions}</div> : null}
        </div>
    );
}
